import React from 'react';
import { Image, StyleSheet, Text, TouchableOpacity, View } from 'react-native';

import { images } from '../assets/images';
import { fonts, scale } from '../Styles';
import { MNOHSTextInput } from './MNOHSTextInput';

export const MNOHSUploadField: React.FC<{ title: string; value: string; onPress: () => void }> = props => {
  return (
    <>
      <Text style={styles.fieldLabel}>{props.title}</Text>
      <View style={styles.uploadContainer}>
        <MNOHSTextInput
          // for some reason, if you separate the styles, it doesn't work
          containerStyle={{ flex: 1 }}
          style={{ flex: 1, paddingLeft: scale(8), fontSize: scale(18) }}
          editable={false}
          pointerEvents="none"
          placeholder="Upload CSV File"
          value={props.value}
          floating
        />
        <TouchableOpacity onPress={props.onPress}>
          <Image source={images.uploadIcon} style={styles.fieldIcon} resizeMode="contain" />
        </TouchableOpacity>
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  uploadContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: scale(8),
    marginBottom: scale(24),
  },
  fieldLabel: {
    ...fonts.descriptionText,
    fontWeight: 'bold',
  },
  fieldIcon: {
    marginLeft: scale(8),
    width: scale(30),
    height: scale(30),
  },
});
